import type { AxiosError } from 'axios'
import { format, parseISO } from 'date-fns'
import { useCallback, useState } from 'react'

import type { Notificacao } from '@/models'
import { servicoBase } from '@/services/servico-base'

import {
  FORMATO_DA_DATA_DA_NOTIFICACAO,
  type NotificacaoApi,
  type ObterNotificacoesResposta,
  type PaginaDeNotificacoes,
  QUANTIDADE_DE_NOTIFICACOES_POR_PAGINA,
  type RespostaDeNotificacoesApi,
} from './tipos'

function formatarData(data: string): string {
  return format(parseISO(data), FORMATO_DA_DATA_DA_NOTIFICACAO)
}

function converterNotificacao(notificacao: NotificacaoApi): Notificacao {
  return {
    id: notificacao.id,
    tipo: notificacao.tipo,
    descricao: notificacao.descricao,
    data: formatarData(notificacao.data),
    visualizado_em: notificacao.visualizado_em
      ? formatarData(notificacao.visualizado_em)
      : null,
    parametros: notificacao.parametros ?? {},
  }
}

export function useObterNotificacoes(): ObterNotificacoesResposta {
  const [loading, setLoading] = useState<boolean>(false)
  const [erro, setErro] = useState<AxiosError | null>(null)

  const obterNotificacoes = useCallback(
    async (pagina: number): Promise<PaginaDeNotificacoes | null> => {
      try {
        setLoading(true)
        setErro(null)

        const { data: resposta } =
          await servicoBase.get<RespostaDeNotificacoesApi>('/v1/notificacoes', {
            params: {
              pagina,
              quantidade: QUANTIDADE_DE_NOTIFICACOES_POR_PAGINA,
            },
          })

        return {
          resultado: resposta.resultados.map(converterNotificacao),
          temMais: resposta.tem_mais,
        }
      } catch (error: any) {
        setErro(error as AxiosError)
      } finally {
        setLoading(false)
      }

      return null
    },
    []
  )

  return [obterNotificacoes, { loading, erro }]
}
